module.exports = {
  Metric_with_such_name_already_exist: 'Название метрики должно быть уникальным.',
  types: {
    a: 'a',
  },
};
